<template>
  <custom-modal
    v-model:visible="dialogVisible"
    header-title="图形验证码"
    :z-index="zIndex"
    :get-container="getContainer"
    :confirm-loading="loading"
    width="420px"
    :show-reset-button="false"
    confirm-button-text="确认"
    @confirm="handleConfirm"
  >
    <div class="py-2">
      <div class="flex items-center gap-3">
        <a-input
          v-model:value="captchaCode"
          placeholder="请输入图形验证码"
          :maxlength="4"
          allow-clear
          size="large"
          @press-enter="handleConfirm"
        />
        <div
          class="w-[120px] h-[44px] shrink-0 rounded border border-slate-200 bg-slate-50 overflow-hidden cursor-pointer flex items-center justify-center dark:border-white/10 dark:bg-white/5"
          @click="refreshCaptcha"
          title="点击刷新验证码"
        >
          <img
            v-if="captchaImage"
            :src="captchaImage"
            alt="图形验证码"
            class="w-full h-full object-contain block"
            draggable="false"
            @contextmenu.prevent
          />
          <a-spin v-else />
        </div>
      </div>
      <p class="text-right text-xs text-slate-500 mt-2 dark:text-white/50">点击图片可刷新验证码</p>
    </div>
  </custom-modal>
</template>

<script>
import { loginApi } from '@/api'
import { message } from 'ant-design-vue'
import CustomModal from '@/components/Modal'

export default {
  name: 'CaptchaDialog',
  components: { CustomModal },
  props: {
    zIndex: {
      type: Number,
      default: undefined
    },
    getContainer: {
      type: Function,
      default: () => document.body
    }
  },
  emits: ['confirm', 'close', 'update:visible'],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      captchaImage: '',
      captchaUuid: '',
      captchaCode: '',
      loading: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        this.dialogVisible = val
        if (val) {
          this.captchaCode = ''
          this.captchaImage = ''
          this.captchaUuid = ''
          this.refreshCaptcha()
        }
      }
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    async refreshCaptcha () {
      try {
        this.loading = true
        const res = await loginApi.getImgCode({})
        // 期望：{ code: 1, msg: "", data: { img_src, uuid } }
        const data = res?.data || {}
        const img = data.img_src || ''
        const uuid = data.uuid || ''
        if (!img || !uuid) {
          message.error('获取图形验证码失败：数据格式不正确')
          return
        }
        this.captchaImage = img
        this.captchaUuid = uuid
      } catch (e) {
        console.error('获取图形验证码失败', e)
        message.error(e?.msg || e?.message || '获取图形验证码失败')
      } finally {
        this.loading = false
      }
    },
    handleConfirm () {
      if (!this.captchaCode || !this.captchaCode.trim()) {
        message.warning('请输入图形验证码')
        return
      }
      if (!this.captchaUuid) {
        message.error('验证码数据异常，请刷新重试')
        return
      }
      this.$emit('confirm', {
        captcha: this.captchaCode.trim(),
        uuid: this.captchaUuid
      })
    },
    handleClose () {
      this.dialogVisible = false
      this.captchaCode = ''
      this.captchaImage = ''
      this.captchaUuid = ''
      this.$emit('close')
    }
  }
}
</script>
